import { api } from '../initFetch'

export const getUserTeams = async (token, TenantId) => {
  const res = await api.post('/p4m/Teams/GetUserTeams', {
    token,
    TenantId,
  })
  return res.json
}
export const getTeamChannels = async (token, teamId, tenantId) => {
  const res = await api.post('/p4m/Teams/GetTeamChannels', {
    token,
    tenantId,
    teamId,
  })
  return res.json
}
export const getChannelFiles = async (token, channelId, teamId, tenantId) => {
  const res = await api.post('/p4m/Teams/GetChannelFiles', {
    token,
    tenantId,
    channelId,
    teamId,
  })
  return res.json
}

export const getTeamsChannelData = async (
  token,
  tenantId,
  teamId = null,
  channelId = null,
  itemId = null
) => {
  const res = await api.post('/p4m/Teams/GetTeamsChannelData', {
    token,
    tenantId,
    channelId,
    teamId,
    itemId
  })
  return res.json
}
